import { generateBaseQueryKeysList } from '@/queries/utils';

export const PERFUSION_SETS_KEYS = {
  main: 'perfusion-sets',
};

export const perfusionSetsQueryKeys = generateBaseQueryKeysList(PERFUSION_SETS_KEYS.main);
